import { Box, Button, Grid, Stack, Typography } from "@mui/material"
import Link from "next/link"
import { ArrowLeft, InfoCircle } from "iconsax-react"
import { Parallax } from "react-scroll-parallax"
import Image from "next/image"
import { useIsMobile } from "../../../../../../hooks/useIsMobile"

const SliderItem = ({ slider }) => {
  const isMobile = useIsMobile()
  return (
    <Grid
      container
      justifyContent='center'
      alignItems='center'
      height='100%'
      spacing={2}
      px={{ xs: 2, md: 10 }}
      py={{ xs: 6, md: 8 }}
    >
      <Grid item xs={12} md={6} order={{ xs: 1, md: 2 }}>
        <Parallax speed={20}>
          <Box position='relative' width='100%' height={{ xs: 300, sm: 400, md: 500 }}>
            <Image
              src={slider.img}
              alt={slider.title || "slider image"}
              fill
              className='custom-img'
              style={{ objectFit: "contain" }}
              priority
            />
          </Box>
        </Parallax>
      </Grid>

      <Grid item xs={12} md={6} order={{ xs: 2, md: 1 }}>
        <Stack spacing={4}>
          <Typography
            component='h2'
            color='#fff'
            sx={{
              fontSize: isMobile ? 32 : 46,
              letterSpacing: 0,
              lineHeight: 1.5,
              fontWeight: "bolder",
              ...(isMobile && { textAlign: "center", pt: 8 })
            }}
          >
            {slider.title}
          </Typography>

          <Typography
            variant='h6'
            fontWeight='lighter'
            sx={{
              color: "#fff",
              ...(isMobile && { textAlign: "center" })
            }}
          >
            {slider.description}
          </Typography>

          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={2}
            mt={4}
            alignItems={{ xs: "stretch", sm: "center" }}
          >
            <Button
              endIcon={<ArrowLeft size={18} />}
              component={Link}
              href={slider.loanUrl}
              variant='contained'
              size='large'
              disableElevation
              fullWidth
              sx={{
                borderRadius: "30px",
                px: 4,
                py: 1.5,
                whiteSpace: "nowrap"
              }}
            >
              درخواست وام از جت وام
            </Button>

            <Button
              endIcon={<InfoCircle size={18} />}
              component={Link}
              href={slider.loanGuideUrl}
              variant='contained'
              size='large'
              disableElevation
              color='secondary'
              fullWidth
              sx={{
                borderRadius: "30px",
                px: 4,
                py: 1.5,
                whiteSpace: "nowrap"
              }}
            >
              راهنمای دریافت وام
            </Button>
          </Stack>
        </Stack>
      </Grid>
    </Grid>
  )
}

export default SliderItem
